import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 pt-5\"><h3 class=\"card-title align-items-start flex-column\"><span class=\"card-label fw-bolder fs-3 mb-1\">New Members</span><span class=\"text-muted mt-1 fw-bold fs-7\">More than 400 new members</span></h3><div class=\"card-toolbar\"><ul class=\"nav\"><li class=\"nav-item\"><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary active fw-bolder px-4 me-1\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_4_tab_1\">Month</a></li><li class=\"nav-item\"><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_4_tab_2\">Week</a></li><li class=\"nav-item\"><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_4_tab_3\">Day</a></li></ul></div></div>", 1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-120px" })
  ])
], -1)
const _hoisted_7 = { class: "symbol symbol-50px" }
const _hoisted_8 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_9 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold d-block fs-7" }, " Rating ", -1)
const _hoisted_11 = { class: "rating" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "btn btn-icon btn-light-twitter btn-sm me-3"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "bi bi-twitter fs-4" })
  ]),
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "btn btn-icon btn-light-facebook btn-sm"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "bi bi-facebook fs-4" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: [[index === 0 && 'show active'], "tab-pane fade"],
            id: `kt_table_widget_4_tab_${index + 1}`
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("table", _hoisted_5, [
                _hoisted_6,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (item1, index1) => {
                    return (_openBlock(), _createBlock("tr", { key: index1 }, [
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_7, [
                          _createVNode("img", {
                            src: item1.image,
                            alt: ""
                          }, null, 8, ["src"])
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("a", _hoisted_8, _toDisplayString(item1.user.name), 1),
                        _createVNode("span", _hoisted_9, _toDisplayString(item1.user.position), 1)
                      ]),
                      _createVNode("td", null, [
                        _hoisted_10,
                        _createVNode("div", _hoisted_11, [
                          (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (i) => {
                            return _createVNode("div", {
                              key: i,
                              class: [[item1.rating >= i && 'checked'], "rating-label me-2"]
                            }, [
                              _hoisted_12
                            ], 2)
                          }), 64))
                        ])
                      ]),
                      _hoisted_13
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 10, ["id"]))
        }), 128))
      ])
    ])
  ], 2))
}